import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../SharedComponents/IconSvg";
import Button from "react-bootstrap/Button";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteCandidateCv } from "../Store/Thunk";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../SharedComponents/GeneralModals";

const CvNavigateButton = ({ previewUrl, setCvFile, setPreviewUrl, candidateId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [confirmationModalIsShown, setConfirmationModalIsShown] = useState(false);

  const handlePreview = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  };

  const DeleteCv = () => {
    dispatch(deleteCandidateCv({ candidateId }));

    setCvFile(null);
    setPreviewUrl(null);
  };

  return (
    <>
      <ConfirmationModal
        isShown={confirmationModalIsShown}
        setIsShown={setConfirmationModalIsShown}
        text={t("cvDeleteConfirmation")}
        confirmationFunction={DeleteCv}
        dismissFunction={() => {
          setConfirmationModalIsShown(false);
        }}
      ></ConfirmationModal>
      <div className={"position-relative"}>
        {Boolean(previewUrl) && (
          <div
            title={t("cvDeleteButtonLabel")}
            className={" position-absolute flex-center rounded-circle hover-border"}
            style={{ height: "20px", width: "20px", top: "-15%", right: "-15%", backgroundColor: "#FAD4D4" }}
            onClick={() => {
              setConfirmationModalIsShown(true);
            }}
          >
            <IconSvg icon={"delete"} width={12} height={12} fill={"#E53935"}></IconSvg>
          </div>
        )}
        <Button
          disabled={!Boolean(previewUrl)}
          title={t("cvPreviewButtonLabel")}
          size={"sm"}
          className={"button secondary"}
          style={{ height: 46, width: 46, padding: 0 }}
          onClick={() => {
            handlePreview();
          }}
        >
          <IconSvg icon={"cv"} fill={"#0077b6"} height={25} width={25} />
        </Button>
      </div>
    </>
  );
};
export default CvNavigateButton;
